(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zare-hareketli-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hexToRgb(hex) {
      var h = (hex || '#AB8571').replace('#', '');
      if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
      var n = parseInt(h.slice(0, 6), 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }

    if (!customElements.get('zare-waves')) {
      class ZareWaves extends HTMLElement {
        connectedCallback() {
          this.canvas = this.querySelector('canvas');
          if (!this.canvas) return;
          this.ctx = this.canvas.getContext('2d');
          this.rgb = hexToRgb(this.dataset.color);
          this.lineCount = parseInt(this.dataset.lines || '28', 10);
          this.speed = parseFloat(this.dataset.speed || '1');
          this.showSparkles = this.dataset.sparkles === 'true';
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.t = Math.random() * 50;
          this.visible = true;
          this.raf = null;
          this.sparkles = [];
          for (var i = 0; i < 46; i++) {
            this.sparkles.push({ x: Math.random(), y: Math.random(), r: 0.6 + Math.random() * 1.4, p: Math.random() * Math.PI * 2, s: 0.6 + Math.random() * 1.2 });
          }
          this.onResize = this.resize.bind(this);
          this.onFrame = this.frame.bind(this);
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this);
          var self = this;
          this.io = new IntersectionObserver(function (entries) {
            self.visible = entries[0].isIntersecting;
            if (self.visible) self.start();
          });
          this.io.observe(this);
          this.resize();
        }
        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          if (this.io) this.io.disconnect();
          if (this.raf) cancelAnimationFrame(this.raf);
          this.raf = null;
        }
        resize() {
          var dpr = Math.min(window.devicePixelRatio || 1, 2);
          this.w = this.clientWidth;
          this.h = this.clientHeight;
          this.canvas.width = Math.max(1, Math.round(this.w * dpr));
          this.canvas.height = Math.max(1, Math.round(this.h * dpr));
          this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          this.draw();
        }
        start() {
          if (this.reduce || this.raf) return;
          this.last = performance.now();
          this.raf = requestAnimationFrame(this.onFrame);
        }
        frame(now) {
          this.raf = null;
          if (!this.visible) return;
          var dt = Math.min((now - this.last) / 1000, 0.05);
          this.last = now;
          this.t += dt * 0.32 * this.speed;
          this.draw();
          this.raf = requestAnimationFrame(this.onFrame);
        }
        draw() {
          var ctx = this.ctx, w = this.w, h = this.h, t = this.t;
          if (!w || !h) return;
          ctx.clearRect(0, 0, w, h);
          var N = Math.max(6, this.lineCount);
          var r = this.rgb[0], g = this.rgb[1], b = this.rgb[2];
          var cy = h * 0.55;
          var amp = h * 0.11;
          var spread = h * 0.34;
          var step = w > 900 ? 6 : 8;
          ctx.lineWidth = 1;
          for (var i = 0; i < N; i++) {
            var k = i / (N - 1) - 0.5;
            var alpha = 0.1 + 0.42 * Math.max(0, 1 - Math.abs(k) * 1.7);
            ctx.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha.toFixed(3) + ')';
            ctx.beginPath();
            for (var x = 0; x <= w + step; x += step) {
              var u = x / w;
              var env = Math.pow(Math.sin(Math.PI * Math.min(Math.max(u, 0), 1)), 1.35);
              var y = cy
                + (0.5 - u) * h * 0.28
                + amp * Math.sin(u * Math.PI * 1.8 + t) * (0.55 + 0.45 * env)
                + k * spread * env * (0.8 + 0.2 * Math.sin(u * 5.5 - t * 1.25 + i * 0.06))
                + h * 0.05 * Math.sin(u * 3.2 - t * 0.7);
              if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
            }
            ctx.stroke();
          }
          if (this.showSparkles) {
            for (var j = 0; j < this.sparkles.length; j++) {
              var sp = this.sparkles[j];
              var a = 0.25 + 0.75 * Math.abs(Math.sin(t * 2.2 * sp.s + sp.p));
              ctx.fillStyle = 'rgba(255,255,255,' + (a * 0.9).toFixed(3) + ')';
              ctx.beginPath();
              ctx.arc(sp.x * w, sp.y * h, sp.r, 0, Math.PI * 2);
              ctx.fill();
            }
          }
        }
      }
      customElements.define('zare-waves', ZareWaves);
    }

    if (!customElements.get('zare-hero-slides')) {
      class ZareHeroSlides extends HTMLElement {
        connectedCallback() {
          this.items = Array.prototype.slice.call(this.querySelectorAll('.zare-slides__item'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.zare-slides__dot'));
          this.len = this.items.length;
          this.index = 0;
          if (this.len < 2) return;
          this.delay = Math.max(2, parseFloat(this.dataset.interval || '5')) * 1000;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.paused = false;
          this.visible = true;
          var self = this;
          this.dots.forEach(function (dot, i) {
            dot.addEventListener('click', function () { self.go(i); self.restart(); });
          });
          this.addEventListener('mouseenter', function () { self.paused = true; self.stop(); });
          this.addEventListener('mouseleave', function () { self.paused = false; self.restart(); });
          var startX = null;
          this.addEventListener('pointerdown', function (e) { startX = e.clientX; });
          this.addEventListener('pointerup', function (e) {
            if (startX === null) return;
            var dx = e.clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) {
              self.go(self.index + (dx < 0 ? 1 : -1));
              self.restart();
            }
          });
          this.io = new IntersectionObserver(function (entries) {
            self.visible = entries[0].isIntersecting;
            self.restart();
          });
          this.io.observe(this);
          this.onBlockSelect = function (e) {
            if (!self.contains(e.target)) return;
            var item = e.target.closest('.zare-slides__item');
            var i = self.items.indexOf(item);
            if (i > -1) { self.go(i); self.stop(); }
          };
          this.onBlockDeselect = function (e) {
            if (self.contains(e.target)) self.restart();
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
          this.restart();
        }
        disconnectedCallback() {
          this.stop();
          if (this.io) this.io.disconnect();
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
        stop() {
          clearTimeout(this.timer);
          this.timer = null;
        }
        restart() {
          this.stop();
          if (this.reduce || this.paused || !this.visible) return;
          var self = this;
          this.timer = setTimeout(function () {
            self.go(self.index + 1);
            self.restart();
          }, this.delay);
        }
        go(n) {
          var prev = this.index;
          var next = ((n % this.len) + this.len) % this.len;
          if (next === prev) return;
          this.index = next;
          this.items.forEach(function (el, i) {
            el.classList.toggle('is-active', i === next);
            el.classList.toggle('is-prev', i === prev);
          });
          this.dots.forEach(function (d, i) {
            d.setAttribute('aria-current', i === next ? 'true' : 'false');
          });
        }
      }
      customElements.define('zare-hero-slides', ZareHeroSlides);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zare-kayan-duyuru"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zare-announce')) {
    class ZareAnnounce extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.zare-ann__item'));
        if (this.items.length < 2) return;
        this.i = 0;
        this.delay = Math.max(2, parseFloat(this.dataset.interval || '4')) * 1000;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = false;
        this.visible = true;
        var self = this;
        this.addEventListener('mouseenter', function () { self.paused = true; self.stop(); });
        this.addEventListener('mouseleave', function () { self.paused = false; self.start(); });
        this.io = new IntersectionObserver(function (e) {
          self.visible = e[0].isIntersecting;
          if (self.visible) { self.start(); } else { self.stop(); }
        });
        this.io.observe(this);
        this.start();
      }
      disconnectedCallback() { this.stop(); if (this.io) this.io.disconnect(); }
      stop() { clearInterval(this.timer); this.timer = null; }
      start() {
        if (this.reduce || this.paused || !this.visible || this.timer) return;
        var self = this;
        this.timer = setInterval(function () {
          self.items[self.i].classList.remove('is-active');
          self.i = (self.i + 1) % self.items.length;
          self.items[self.i].classList.add('is-active');
        }, this.delay);
      }
    }
    customElements.define('zare-announce', ZareAnnounce);
  }

  } catch(e) { console.error(e); }
})();
})();
